import { render, staticRenderFns } from "./CompText2Cols.vue?vue&type=template&id=2740f39a"
import script from "./CompText2Cols.vue?vue&type=script&lang=js"
export * from "./CompText2Cols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports